'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  tag: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]),
  className: _react.PropTypes.any
};

var defaultProps = {
  tag: 'div'
};

var PopoverContent = function PopoverContent(props) {
  var className = props.className;
  var Tag = props.tag;

  var attributes = _objectWithoutProperties(props, ['className', 'tag']);

  var classes = (0, _classnames2.default)(className, 'popover-content');

  return _react2.default.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverContent.propTypes = propTypes;
PopoverContent.defaultProps = defaultProps;

exports.default = PopoverContent;


/*****************
 ** WEBPACK FOOTER
 ** ./~/reactstrap/lib/PopoverContent.js
 ** module id = 194
 ** module chunks = 0
 **/